module.exports = {"420103001":"民族街","420103002":"花楼街","420103003":"水塔街","420103004":"民权街","420103005":"满春街","420103006":"民意街","420103007":"新华街","420103008":"万松街","420103009":"唐家墩街","420103010":"北湖街","420103011":"前进街","420103012":"常青街","420103013":"汉兴街","420103400":"江汉经济开发区","420103401":"武汉中央商务区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420103.json
// module id = 1550
// module chunks = 0